/**
 * iter-75 PART 4 — LookFilter
 *
 * Compact horizontal chip rail that lets the user narrow a list of
 * state_entries down to a single Look value. Used on CharacterDetail
 * and SceneDetail to surface "show me only the 'Bloody nose' looks
 * for this scene" without leaving the page.
 *
 * It's purely presentational: filtering happens client-side in the
 * parent (the entries are already loaded). Returns an empty render
 * when there are 0 or 1 distinct looks because the chip rail adds
 * no value at that volume.
 */
import { Check } from "lucide-react";

export default function LookFilter({
    looks,
    value,
    onChange,
    testidPrefix = "look-filter",
    className = "",
}) {
    const distinct = Array.from(
        new Set(
            (looks || [])
                .map((v) => (typeof v === "string" ? v.trim() : ""))
                .filter(Boolean),
        ),
    );
    if (distinct.length < 1) return null;
    return (
        <div
            data-testid={`${testidPrefix}-rail`}
            className={`flex items-center gap-1.5 overflow-x-auto pb-1 ${className}`}
        >
            <span className="shrink-0 text-[10px] uppercase tracking-[0.2em] text-neutral-500 mr-1">
                Look
            </span>
            <button
                type="button"
                data-testid={`${testidPrefix}-all`}
                data-active={!value ? "true" : "false"}
                onClick={() => onChange("")}
                className={`instant-tap shrink-0 inline-flex items-center h-7 px-2.5 rounded-full text-xs border ${
                    !value
                        ? "bg-primary text-primary-foreground border-primary font-semibold"
                        : "bg-secondary text-neutral-200 border-white/10 hover:bg-white/10"
                }`}
            >
                All
            </button>
            {distinct.map((v) => {
                const active = (value || "").toLowerCase() === v.toLowerCase();
                return (
                    <button
                        key={v}
                        type="button"
                        data-testid={`${testidPrefix}-${v}`}
                        data-active={active ? "true" : "false"}
                        onClick={() => onChange(active ? "" : v)}
                        className={`instant-tap shrink-0 inline-flex items-center gap-1 h-7 px-2.5 rounded-full text-xs border ${
                            active
                                ? "bg-primary text-primary-foreground border-primary font-semibold"
                                : "bg-secondary text-neutral-200 border-white/10 hover:bg-white/10"
                        }`}
                    >
                        {active ? <Check size={11} /> : null}
                        {v}
                    </button>
                );
            })}
        </div>
    );
}
